import * as types from "./actionTypes"

export const buscarPlanoContasCadastro = empresa => ({
  type: types.BUSCAR_PLANO_CONTAS_CADASTRO,
  payload: { empresa },
})

export const buscarPlanoContasCadastroSucesso = (contas, grupos) => ({
  type: types.BUSCAR_PLANO_CONTAS_CADASTRO_SUCESSO,
  payload: { contas, grupos },
})

export const buscarPlanoContasCadastroFalha = erro => ({
  type: types.BUSCAR_PLANO_CONTAS_CADASTRO_FALHA,
  payload: erro,
})

// itens: contas novas (sem id), alteradas (com id) ou { id, excluir: true }
export const salvarPlanoContasLote = ({ idEmpresa, itens, confirmado }) => ({
  type: types.SALVAR_PLANO_CONTAS_LOTE,
  payload: { idEmpresa, itens, confirmado: confirmado === true },
})

export const salvarPlanoContasLoteSucesso = contas => ({
  type: types.SALVAR_PLANO_CONTAS_LOTE_SUCESSO,
  payload: contas,
})

export const salvarPlanoContasLoteImpactos = impactos => ({
  type: types.SALVAR_PLANO_CONTAS_LOTE_IMPACTOS,
  payload: impactos,
})

export const salvarPlanoContasLoteErros = erros => ({
  type: types.SALVAR_PLANO_CONTAS_LOTE_ERROS,
  payload: erros,
})

export const salvarPlanoContasLoteFalha = erro => ({
  type: types.SALVAR_PLANO_CONTAS_LOTE_FALHA,
  payload: erro,
})

export const limparImpactosPlanoContas = () => ({
  type: types.LIMPAR_IMPACTOS_PLANO_CONTAS,
})
